import script from "./VitaEmployeeAdd.vue?vue&type=script&setup=true&lang=ts"
export * from "./VitaEmployeeAdd.vue?vue&type=script&setup=true&lang=ts"

import "./VitaEmployeeAdd.vue?vue&type=style&index=0&id=5de5c51e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5de5c51e"]])

export default __exports__